export default __webpack_public_path__ + "static/media/pants_new_grey.57aeb81a.jpg";